enum FunnelKey {
  amazon = "amazon",
  cdc_dpp = "cdcdpp",
  demo = "demo",
  eternalHealth = "eternalhealth",
  evernorth = "evernorth",
  kwikTrip = "kwiktrip",
  lilly = "lilly",
  lillyTeam = "lilly-team",
  medicare = "medicare",
  none = "_none_",
  prescryptive = "prescryptive",
  promo = "promo",
  smithrx = "smithrx",
  solera = "wellvolution",
  bjs = "bjs",
  cignaIfp = "cigna-ifp",
  stateOfIndiana = "state-of-indiana",
  test = "test",
  transcarent = "transcarent",
  treatmentPlan = "treatment-plan",
  universal = "universal",
  weightLoss = "weight-loss",
  novocare = "novocare",
  stateOfGeorgia = "state-of-georgia",
  personifyHealth = "personify-health"
}

export default FunnelKey;
